import Calendar from '@fullcalendar/react'; // => request placed at the top
// @fullcalendar
import plLocale from '@fullcalendar/core/locales/pl';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import timelinePlugin from '@fullcalendar/timeline';
//
import { useEffect } from 'react';
// @mui
import { useTheme } from '@mui/material';
// utils
// hooks
import { useBoolean } from '../hooks/use-boolean';
// _mock
// api
// components
// types
//
import { DatesSetArg, EventClickArg } from '@fullcalendar/core';
import CalendarEvent from '../calendar-event';
import CalendarToolbar from '../calendar-toolbar';
import { useCalendar } from '../hooks';
import { StyledCalendar } from '../styles';
import { ICalendarEvent } from '../types/calendar';
// ----------------------------------------------------------------------

export type CalendarViewTypes = {
  events: ICalendarEvent[];
  onOpenSchedule: () => void;
  onStaffBooking?: () => void;
  onTimeOff?: () => void;
  onEventClick?: (arg: EventClickArg) => void;
  filtersOpen?: boolean;
  onToggleFilters?: () => void;
  filtersComponent?: React.ReactNode;
  filtersActive?: boolean;
  onDatesSet?: (arg: DatesSetArg) => void;
  isOrganizationAdmin?: boolean;
};

export default function CalendarView({
  events,
  onOpenSchedule,
  onStaffBooking,
  onTimeOff,
  onEventClick,
  filtersOpen = false,
  onToggleFilters,
  filtersComponent,
  filtersActive = false,
  onDatesSet,
  isOrganizationAdmin = false,
}: CalendarViewTypes) {
  const theme = useTheme();
  const openFilters = useBoolean();

  const {
    calendarRef,
    view,
    date,
    onDatePrev,
    onDateNext,
    onDateToday,
    onChangeDate,
    onChangeView,
    onInitialView,
  } = useCalendar();

  // const currentEvent = useEvent(events, selectEventId, selectedRange, openForm);

  useEffect(() => {
    onInitialView();
  }, [onInitialView]);

  return (
    <>
      <StyledCalendar>
        <CalendarToolbar
          date={date}
          view={view}
          loading={false}
          onNextDate={onDateNext}
          onPrevDate={onDatePrev}
          onToday={onDateToday}
          onChangeView={onChangeView}
          onChangeDate={onChangeDate}
          onOpenFilters={onToggleFilters || openFilters.onTrue}
          onOpenSchedule={onOpenSchedule}
          onStaffBooking={onStaffBooking}
          onTimeOff={onTimeOff}
          filtersActive={filtersActive}
          isOrganizationAdmin={isOrganizationAdmin}
        />

        {filtersComponent}

        <Calendar
          locale={plLocale}
          firstDay={1}
          weekends
          allDaySlot={false}
          rerenderDelay={10}
          allDayMaintainDuration
          eventResizableFromStart
          ref={calendarRef}
          initialDate={date}
          initialView={view}
          dayMaxEventRows={3}
          eventDisplay="block"
          events={events}
          headerToolbar={false}
          eventClick={onEventClick}
          eventDidMount={(info) => {
            const v = info.event.extendedProps.visit;
            const to = info.event.extendedProps.timeOff;
            if (v?.id) info.el.setAttribute('data-testid', `calendar-visit-${v.id}`);
            else if (to) info.el.setAttribute('data-testid', 'calendar-timeoff');
          }}
          height={'100%'}
          nowIndicator
          longPressDelay={250}
          eventLongPressDelay={250}
          selectLongPressDelay={250}
          slotLabelFormat={{
            hour: 'numeric',
            minute: '2-digit',
          }}
          slotDuration="00:10:00"
          plugins={[
            listPlugin,
            dayGridPlugin,
            timelinePlugin,
            timeGridPlugin,
            interactionPlugin,
          ]}
          scrollTime={new Date().getHours().toString() + ':00'}
          datesSet={onDatesSet}
          eventContent={(eventContent) => (
            <CalendarEvent event={eventContent} />
          )}
        />
      </StyledCalendar>
    </>
  );
}
